import React, {useEffect} from 'react'
import Modal from '../../../../../../libs/_fri/components/CustomModal/CustomModal'
import {useFormik} from 'formik'
import {useSelector} from 'react-redux'
import {RootState} from '../../../../../../redux/store'
import {useCreateUserMutation} from '../../../../../../redux/api/services/user'
import {IFormCreateUser, schemaCreateUser} from '../../core/interface'
import Select from 'react-select'
import {UserRole} from '../../../../../../interfaces/user'
import {getOptionsRoles} from '../../../../../../helpers/utilities'
import RoleBaseGuard from '../../../../../../helpers/elements/RoleBaseGuard'

interface Props {
  handleClose: () => void
}

export const UserCreateModal = ({handleClose}: Props) => {
  const [createUser, {isSuccess, reset, isLoading}] = useCreateUserMutation()
  const infoState = useSelector((state: RootState) => state.info)
  const currentUser = useSelector((state: RootState) => state.authSlice.user)

  const initialValues: IFormCreateUser = {
    name: '',
    email: '',
    phoneNumber: '',
    role: '',
  }

  useEffect(() => {
    if (!isSuccess) return
    reset()
    formik.resetForm()
    handleClose()
  }, [isSuccess])

  const handleSubmit = (values: IFormCreateUser) => {
    const requestData = {
      info: infoState,
      requestContent: {
        name: values.name,
        email: values.email,
        phoneNumber: values.phoneNumber,
        role: values.role as UserRole,
      },
    }
    createUser(requestData)
  }

  const formik = useFormik({
    initialValues,
    validationSchema: schemaCreateUser,
    onSubmit: handleSubmit,
  })

  useEffect(() => {
    if (!currentUser?.type) return
    if (currentUser.type === 'authorizer') {
      formik.setFieldValue('role', 'operative')
    }
  }, [currentUser])

  return (
    <Modal
      handleClose={handleClose}
      handleConfirm={formik.handleSubmit}
      variant='primary'
      size='lg'
      isLoading={isLoading}
    >
      <div className='d-flex flex-column px-21'>
        <span className='fs-2x text-primary-dark fw-semibold text-center mb-15'>
          Crear nuevo usuario
        </span>

        <div className='row'>
          <div className='col-md-12'>
            <label className='form-label mb-3 text-gray fs-2'>Nombre</label>
            <input
              name='name'
              type='text'
              placeholder='Nombre completo'
              className='form-control form-control-lg form-control-solid text-primary-dark fs-2'
              value={formik.values.name}
              onChange={formik.handleChange}
            />
            <div className='text-danger mt-2'>{formik.touched.name && formik.errors.name}</div>
          </div>
        </div>

        <div className='row mt-11'>
          <div className='col-md-12'>
            <label className='form-label mb-3 text-gray fs-2'>Correo electrónico</label>
            <input
              name='email'
              type='email'
              placeholder='correo@ejemplo.com'
              className='form-control form-control-lg form-control-solid text-primary-dark fs-2'
              value={formik.values.email}
              onChange={formik.handleChange}
            />
            <div className='text-danger mt-2'>{formik.touched.email && formik.errors.email}</div>
          </div>
        </div>

        <div className='row mt-11'>
          <div className='col-md-12'>
            <label className='form-label mb-3 text-gray fs-2'>Teléfono</label>
            <input
              name='phoneNumber'
              type='text'
              placeholder='Número de teléfono'
              className='form-control form-control-lg form-control-solid text-primary-dark fs-2'
              value={formik.values.phoneNumber}
              onChange={formik.handleChange}
            />
            <div className='text-danger mt-2'>
              {formik.touched.phoneNumber && formik.errors.phoneNumber}
            </div>
          </div>
        </div>

        <RoleBaseGuard permission='new_user_admin'>
          <div className='mt-11'>
            <label className='form-label mb-3 text-gray fs-2'>Rol</label>
            <Select
              className='react-select-styled react-select-solid react-select-lg fs-2'
              classNamePrefix='react-select'
              options={getOptionsRoles(currentUser)}
              placeholder='Selecciona un Rol'
              onChange={(value) => formik.setFieldValue('role', value?.value)}
            />
            <div className='text-danger mt-2'>{formik.touched.role && formik.errors.role}</div>
          </div>
        </RoleBaseGuard>
      </div>
    </Modal>
  )
}
